import React from 'react';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import AvPauseCircleOutline from "material-ui/svg-icons/av/pause-circle-outline";
import AvPlayCircleOutline from "material-ui/svg-icons/av/play-circle-outline";
import AvPlayArrow from "material-ui/svg-icons/av/play-arrow";

export default class ItemsToolbar extends React.Component {
    render() {
        return (
            <div style={{ display: 'flex' }}>

                <div style={{ flexGrow: 1 }}>

                    {this.props.hasSelected &&
                        <RaisedButton
                            label="Executar"
                            labelPosition="after"
                            icon={<AvPlayArrow />}
                            secondary={true}
                            onClick={this.props.handleRun}
                            disabled={this.props.requesting} />}

                    {this.props.hasSelected &&
                        <FlatButton
                            label="Ativar"
                            labelPosition="after"
                            icon={<AvPlayCircleOutline />}
                            onClick={this.props.handleResume}
                            disabled={this.props.requesting}
                            style={{ marginLeft: 12 }} />}

                    {this.props.hasSelected &&
                        <FlatButton
                            label="Desativar"
                            icon={<AvPauseCircleOutline />}
                            labelPosition="after"
                            onClick={this.props.handlePause}
                            disabled={this.props.requesting} />}

                </div>
                {!this.props.allRowsSelected && 
                    <div style={{ alignSelf: 'center', fontWeight: 'bold' }}>
                        {`${this.props.selectedLength} ${this.props.selectedLength === 1 ? 'tarefa selecionada' : 'tarefas selecionadas'}`}
                    </div>
                }
                {this.props.allRowsSelected && 
                    <div style={{ alignSelf: 'center', fontWeight: 'bold' }}>
                        {`${this.props.tableDataLength} ${this.props.tableDataLength === 1 ? 'tarefa selecionada' : 'tarefas selecionadas'}`}
                    </div>
                }
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/view/scheduler/list/ItemsToolbar.js